import { LEXILE_LEVELS } from '../LevelTest/lexileReportData';

export const libraryLevelOptions = (service, t = value => value) => service === 'levelup'
  ? [{ value: '-1', label: t('Phonics Class') }, { value: '0', label: t('Phonics Readers') }, { value: '1', label: 'mx 01' }, { value: '2', label: 'mx 02' }]
  : LEXILE_LEVELS.map(item => ({ value: String(item.level), label: `mx ${String(item.level).padStart(2, '0')} (${item.range})` }));

export const allLibraryLevelsLabel = (service, text) => service === 'levelup'
  ? text('All Ebook Level Books', '전체 전자책') : text('All aiR Level Books', '전체 aiR 도서');
